import axios from 'axios';
import { atom, selector, SetterOrUpdater } from 'recoil';
import styled from 'styled-components';
import { URL_FOUNDATION } from '../../config/keys';
import React from 'react';
import { BorderColor } from '../../styles/global/css/Utils';
import CloseIcon from '../../styles/custom-icons/close';

type AiAgentWithoutId = {
	name: string
	body: string
	description?: string
}

export type AiAgent = AiAgentWithoutId & {
	id: number
}

export const SIDELY_AI_AGENTS: AiAgent[] = [
	{ id: -1, name: '🎯 Résumé rapports', body: 'Tu es un agent de TEST, commence ta réponse par `JE SUIS UN AGENT DE TEST, VOILA MA REPONSE:`', description: '' },
	{ id: -2, name: '🚨 Détection Anomalies', body: '', description: '' },
	{ id: -3, name: '🎬 Actions correctives', body: '', description: '' },
];

// -----------------------[ ATOM ]----------------------- //
//
const _aiAgentAtoms = atom({
	key: 'atom_ai_agents', // UNIQUE ID
	default: getAiAgents(),
});

export const AAiAgents = selector<AiAgent[]>({
	key: 'AAiAgents',
	get: ({ get }) => get(_aiAgentAtoms),
	set: ({ set }, newValue) => set(_aiAgentAtoms, newValue)
});

// -----------------------[ API ]------------------------ //
async function waitForToken(): Promise<void> {
	while (!axios.defaults.headers.common.Authorization) {
		await new Promise(resolve => setTimeout(resolve, 100));
	}
}

export async function getAiAgents(): Promise<AiAgent[]> {
	await waitForToken();
	try {
		return await axios.get<AiAgent[]>(`${URL_FOUNDATION ?? ''}/api/v2/ai/agent`).then(res => res.data);
	} catch (e) {
		console.log(e);
		return [];
	}
}

export async function postAiAgent(body: AiAgentWithoutId, setAtom: SetterOrUpdater<AiAgent[]>): Promise<void> {
	return axios.post<number>(`${URL_FOUNDATION ?? ''}/api/v2/ai/agent`, body)
		.then(res => setAtom((prev) => [...prev, { ...body, id: res.data }]));
}

export async function putAiAgent(id: number, body: Partial<AiAgentWithoutId>, setAtom: SetterOrUpdater<AiAgent[]>): Promise<void> {
	return axios.put<void>(`${URL_FOUNDATION ?? ''}/api/v2/ai/agent/${id}`, body)
		.then(() => setAtom((prev) => {
			const n = [...prev];
			const index = n.findIndex(agent => agent.id === id);
			if (index !== -1) {
				n[index] = { ...n[index], ...body };
			}
			return n;
		}));
}

export async function deleteAiAgent(id: number, setAtom: SetterOrUpdater<AiAgent[]>): Promise<void> {
	return axios.delete<void>(`${URL_FOUNDATION ?? ''}/api/v2/ai/agent/${id}`).then(() => setAtom((prev) => [...prev.filter(a => a.id !== id)]));
}

// -----------------------[ DIV ]------------------------ //
export function AiAgentButton(props: { onClick?: (agent: AiAgent) => void, agent: AiAgent, style?: React.CSSProperties, deleteMode?: boolean }) {
	return <AiAgentWrapperDiv onClick={() => props.onClick?.(props.agent)} disabled={!props.onClick} style={props.style}>
		{props.agent.name}
		{props.deleteMode && <CloseIcon />}
	</AiAgentWrapperDiv>;
}

export const AiAgentWrapperDiv = styled.button`
	border-radius: 10px;
	padding: 5px 10px;
	font-size: 12px;
  	text-wrap: nowrap;
  	flex-shrink: 0;
   	width: fit-content;
    display: flex;
    align-items: center;
  	&:hover {
   		background-color: color-mix(in oklab, ${BorderColor}, transparent 50%);
   }
   ${props => props.disabled ? '' : 'background: none;'}
  	border: 1px solid ${BorderColor};
`;
